import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["tab", "link"];

    updateEditLink(event) {
        // Find the active tab
        const activeTab = this.tabTargets.find((tab) =>
            tab.classList.contains("active")
        );

        if (!activeTab) return;

        // Get the tab value
        const tabValue = activeTab.dataset.tabValue;

        // Use the current link's href as the base URL
        const link = this.linkTarget;
        const currentUrl = new URL(link.href);

        // Update the query parameter
        currentUrl.searchParams.set("tab", tabValue);

        // Update the link's href
        link.href = currentUrl.toString();
    }
}